import React, {useEffect, useState} from 'react';
import {useQuery} from "react-query";
import {endOfDay, format, parseISO} from 'date-fns';

import ClientNavbar from "../../components/ClientNavbar";
import {DownloadIcon, FilterIcon, Search} from "../../components/icons";
import {Loader, Table} from "../../components/common";
import {CreateRequestModal, DownloadModal, FilterModals} from "../../components/modal";
import {useAlert} from "../../components/common/Alert";
import {ALERT_TYPES, IApplications, PAGINATION} from "../../types";
import {Pagination} from "../../components/ui";

const Applications = () => {
  const { setAlert } = useAlert();
  const [openRequestModal, setOpenRequestModal] = useState<boolean>(false);
  const [openDownloadModal, setOpenDownloadModal] = useState<boolean>(false);
  const [openFilterModal, setOpenFilterModal] = useState<boolean>(false);
  const [totalPages, setTotalPages] = useState<Array<number>>([]);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [dateStart, setDateStart] = useState<string>(format((new Date()).setDate((new Date()).getDate() - 1), "dd-MM-yyyy"));
  const [dateEnd, setDateEnd] = useState<string>(format(endOfDay(new Date()), "dd-MM-yyyy"));
  const [filterBank, setFilterBank] = useState<string | number | null>(null);
  const [filterProduct, setFilterProduct] = useState<string | number | null>(null);

  const { data, error, isLoading }: {
    data: IApplications | undefined;
    error: any;
    isLoading: boolean
  } = useQuery(["statisticsOrders", dateStart, dateEnd, currentPage, PAGINATION.PAGE_SIZE, filterProduct, filterBank], {
    refetchOnWindowFocus: false
  });

  const handleChangePage = (page: number) => setCurrentPage(page);

  useEffect(() => {
    if (data) {
      const totalPages = Math.ceil(data?.count / PAGINATION.PAGE_SIZE);
      const arrOfPages = [];

      let item = 0;
      for (let i = 0; i < totalPages; i++) {
        item++;
        arrOfPages.push(item);
      }

      setTotalPages(arrOfPages);
    }
  }, [data]);

  if (error) {
    console.log('err ', error);
    // setAlert(error, ALERT_TYPES.ERROR);
  }

  const handleCloseModal = () => {
    setOpenRequestModal(false);
    setOpenDownloadModal(false);
    setOpenFilterModal(false);
  }

  const applyData = (data: any) => {
    const { start, end, bank, product } = data;

    setDateStart(start ? format(parseISO(start), 'dd-MM-yyyy') : '');
    setDateEnd(end ? format(parseISO(end), 'dd-MM-yyyy') : '');
    setFilterBank(bank === 'Все' ? null : bank);
    setFilterProduct(product === 'Все' ? null : product);
  }

  return (
    <div className="relative min-h-screen">
      <ClientNavbar />
      <div className="py-8 mx-auto max-w-[1320px] w-full px-4">
        {isLoading && <Loader />}
        <CreateRequestModal open={openRequestModal} onClose={handleCloseModal} />
        <DownloadModal open={openDownloadModal} onClose={handleCloseModal} />
        <FilterModals open={openFilterModal} onClose={handleCloseModal} applyData={applyData} />
        <div className="flex items-center justify-between lg:flex-col lg:items-start ">
          <div className="flex items-center gap-4 lg:mb-3">
            <p className="font-bold text-[32px] leading-[39px]">Заявки</p>
            <span onClick={() => setOpenFilterModal(true)}>
              <FilterIcon />
            </span>

            {/*<span>*/}
            {/*  <Search />*/}
            {/*</span>*/}
          </div>

          <div className="flex items-center gap-1">
            <span
              className="p-2 rounded-sm bg-mainBlack/5 cursor-pointer hover:bg-gray duration-150 ease-in"
              onClick={() => setOpenDownloadModal(true)}
            >
              <DownloadIcon />
            </span>

            <span
              className="py-2 px-6 text-black text-[14px] leading-[16px] font-medium rounded-sm bg-mainBlack/5 cursor-pointer hover:bg-gray duration-150 ease-in"
              onClick={() => setOpenRequestModal(true)}
            >
              Создать заявку
            </span>
          </div>
        </div>

        <div className="w-full h-full min-h-[75vh] overflow-x-scroll">
          {
            data?.results
            ? <Table results={data?.results}/>
            :  (
              <div className="h-[70vh] flex items-center justify-center">
                <p className="text-center text-black text-[20px] leading-[22px] font-medium">
                  У вас нет заявок. Нажмите кнопку “Создать заявку” и заполните форму
                </p>
              </div>
            )
          }

          {
            totalPages?.length > 1 &&
            <Pagination
              currentPage={currentPage}
              pages={totalPages}
              handleChangePage={handleChangePage}
            />
          }
        </div>
      </div>
    </div>
  )
};

export default Applications;
